import { render } from "./StockAdjustmentModal.vue?vue&type=template&id=6a6a1d74"
import script from "./StockAdjustmentModal.vue?vue&type=script&lang=js"
export * from "./StockAdjustmentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__